<template>
<!-- eslint-disable -->
<div id="DetailContrastTable">
  <table>
    <tbody>
      <tr>
        <td>
          {{$t('avatamsaka.levelThree.sign')}}
        </td>
        <td>
          {{$t('avatamsaka.levelThree.fullName')}}
        </td>
      </tr>
      <tr>
        <td>
          
            《校勘本》
        </td>
        <td>
          
            《藏、漢〈華嚴經•淨行品〉五異譯校勘本》
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#27714;&#20315;&#12299;
        </td>
        <td>
          
            &#25903;&#35734;&#35695;&#12298;&#35576;&#33769;&#34217;&#27714;&#20315;&#26412;&#26989;&#32147;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#26412;&#26989;&#12299;
        </td>
        <td>
          
            &#25903;&#35609;&#35695;&#12298;&#33769;&#34217;&#26412;&#26989;&#32147;&bull;&#39000;&#34892;&#21697;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#20845;&#21313;&#12299;
        </td>
        <td>
          
            &#20315;&#38464;&#36299;&#38464;&#32645;&#35695;&#12298;&#20845;&#21313;&#33775;&#22196;&bull;&#28136;&#34892;&#21697;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#20843;&#21313;&#12299;
        </td>
        <td>
          
            &#23526;&#21449;&#38627;&#38464;&#35695;&#12298;&#20843;&#21313;&#33775;&#22196;&bull;&#28136;&#34892;&#21697;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#34255;&#35695;&#12299;
          
        </td>
        <td>
          
            Jinamitra&#65292;Surendrabodhi&#21644;&#3937;&#3962;&#3851;&#3940;&#3962;&#3942;&#3851;&#3942;&#4001;&#3962;&#35695;&#12298;&#34255;&#35695;&#33775;&#22196;&bull;&#28136;&#34892;&#21697;&#12299;
          
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#39640;&#12299;
        </td>
        <td>
          
            &#12298;&#26223;&#21360;&#39640;&#40599;&#22823;&#34255;&#32147;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#30951;&#12299;
        </td>
        <td>
          &#12298;&#23435;&#29256;&#30951;&#30722;&#22823;&#34255;&#32147;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          《大》/ T
        </td>
        <td>
          
            &#12298;&#22823;&#27491;&#26032;&#33065;&#22823;&#34255;&#32147;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          &#12298;&#25958;&#12299;
        </td>
        <td>
          
            &#12298;&#25958;&#29004;&#23542;&#34255;&#12299;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#32854;&#12299;t
        </td>
        <td>
          
            &#12298;&#22823;&#27491;&#26032;&#20462;&#22823;&#34255;&#32147;&#12299;&#25152;&#21443;&#32771;&#20043;&#27491;&#20489;&#38498;&#32854;&#35486;&#34255;&#26412;&#65288;&#22825;&#24179;&#23531;&#32147;&#65289;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#32854;&#20057;&#12299;t
        </td>
        <td>
          
            &#12298;&#22823;&#27491;&#26032;&#20462;&#22823;&#34255;&#32147;&#12299;&#25152;&#21443;&#32771;&#20043;&#27491;&#20489;&#38498;&#32854;&#35486;&#34255;&#26412;&#21029;&#23531;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#23470;&#12299;t
        </td>
        <td>
          
            &#12298;&#22823;&#27491;&#26032;&#20462;&#22823;&#34255;&#32147;&#12299;&#25152;&#21443;&#32771;&#20043;&#23470;&#20839;&#30465;&#22294;&#26360;&#23534;&#26412;&#65288;&#33290;&#23435;&#26412;&#65289;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#23435;&#12299;t
        </td>
        <td>
          &#12298;&#22823;&#27491;&#26032;&#20462;&#22823;&#34255;&#32147;&#12299;&#25152;&#21443;&#32771;&#20043;&#21335;&#23435;&#24605;&#28330;&#34255;
        </td>
      </tr>
      <tr>
        <td>
          &#12298;&#20803;&#12299;t
        </td>
        <td>
          &#12298;&#22823;&#27491;&#26032;&#20462;&#22823;&#34255;&#32147;&#12299;&#25152;&#21443;&#32771;&#20043;&#20803;&#22823;&#26222;&#23527;&#23546;&#34255;
        </td>
      </tr>
      <tr>
        <td>
          &#12298;&#26126;&#12299;t
        </td>
        <td>
          &#12298;&#22823;&#27491;&#26032;&#20462;&#22823;&#34255;&#32147;&#12299;&#25152;&#21443;&#32771;&#20043;&#26126;&#26041;&#20874;&#34255;
        </td>
      </tr>
      <tr>
        <td>
          C
        </td>
        <td>
          
            &#21331;&#23612;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Co ne&#65289;
        </td>
      </tr>
      <tr>
        <td>
          D
        </td>
        <td>
          
            &#24503;&#26684;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Sde dge&#65289;
        </td>
      </tr>
      <tr>
        <td>
          F
        </td>
        <td>
          
            &#26222;&#25166;&#23531;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Phug brag&#65289;
        </td>
      </tr>
      <tr>
        <td>
          H
        </td>
        <td>
          
            &#25289;&#34217;&#29256;&#21051;&#26412;&#65288;&#38634;&#29256;&#65289;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Zhol&#65288;Lhasa&#65289;&#65289;
          
        </td>
      </tr>
      <tr>
        <td>
          J
        </td>
        <td>
          
            &#29702;&#22616;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Li thang&#65289;
        </td>
      </tr>
      <tr>
        <td>
          M
        </td>
        <td>
          
            &#12298;&#20013;&#33775;&#22823;&#34255;&#32147;&#8231;&#29976;&#29664;&#29246;&#12299;&#65288;&#23565;&#21208;&#26412;&#65289;&#65288;Dpe bsdur ma&#65289;
            
        </td>
      </tr>
      <tr>
        <td>
          N
        </td>
        <td>
          
            &#32013;&#21776;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Snar thang&#65289;
        </td>
      </tr>
      <tr>
        <td>
          Q
        </td>
        <td>
          
            &#21271;&#20140;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Pe cing&#65289;
        </td>
      </tr>
      <tr>
        <td>
          S
        </td>
        <td>
          
            &#26421;&#23470;&#23531;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Stog palace&#65289;
        </td>
      </tr>
      <tr>
        <td>
          U
        </td>
        <td>
          
            &#24235;&#20523;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;Khu re&#65289;
        </td>
      </tr>
      <tr>
        <td>
          Y
        </td>
        <td>
          
            &#27704;&#27138;&#29256;&#21051;&#26412;&#12298;&#29976;&#29664;&#29246;&#12299;&#65288;G.yung lo&#65289;
        </td>
      </tr>
      <tr>
        <td>
          
            &#12298;&#28450;&#35486;&#12299;
        </td>
        <td>
          
            羅竹風主編《漢語大詞典》，上海：漢語大詞典出版社。
        </td>
      </tr>
      <tr>
        <td>
          《藏漢》
        </td>
        <td>
          張怡蓀編《藏漢大辭典》，北京：民族出版社。
        </td>
      </tr>
      <tr>
        <td>
          JH
        </td>
        <td>
          Jeffrey Hopkins ed. Tibetan-Sanskrit-English Dictionary
        </td>
      </tr>
      <tr>
        <td>
          Mvyt
        </td>
        <td>
          榊亮三郎編《梵、藏、漢、和四譯對校〈飜譯名義大集〉》，東京：財團法人鈴木學術財團。
        </td>
      </tr>
      <tr>
        <td>
          YOGA
        </td>
        <td>
          Koitsu Yokoyama & Takayuki Hirosawa. Sanskrit-Tibetan-Chinese & Tibetan-Sanskrit-Chinese Dictionary of Buddhist Terminology (based
          on Yogācārabhūmi). Tokyo: Sankibo Busshorin Publishing Co., Ltd.
        </td>
      </tr>
    </tbody>
  </table>

</div>
</template>

<script>
export default {
  name: 'DetailContrastTable',
};
</script>
<style lang="scss" scoped>

#DetailContrastTable {
  table {
    margin: 2em;
    tbody {
      tr {
        td {
          padding: 1em;
          p {
            margin: 0px;
          }
        }
        td:first-child {
          min-width: 8em;
          text-align: center;
        }
      }
      tr:nth-child(odd) {
        background-color: #0968443d;
      }
      tr:first-child {
        background: #096843;
        color: #ffffff;
        text-align: left;
        td {
          padding: 1em;
        }
      }
    }
    @media (max-width: 768px) {
      margin: 0px;
        display: block;
        tbody {
          display: block;
          tr {
            display: flex;
            flex-direction: column;
            td:first-child {
              font-weight: bolder;
              border-bottom: dashed 1px grey;
            }
            td {
              padding: 0px;
              margin: 0.5em;
            }
          }
          tr:first-child {
            td:nth-child(2) {
              text-align: center;
            }
            td {
              padding: 0px;
            }
          }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DetailContrastTable.vue